import { StateCreator } from "zustand";

export interface ClarityViewerState {
    url?: string;
    visible: boolean;
}

export interface ClarityViewerSlice {
    clarityViewer: ClarityViewerState;
    setClarityViewer: (state: ClarityViewerState) => void;
    updateClarityViewer: (partialState: Partial<ClarityViewerState>) => void;
    showClarityViewer: () => void;
    hideClarityViewer: () => void;
}

const initialClarityViewerState: ClarityViewerState = { url: undefined, visible: false };

export const createClarityViewerSlice: StateCreator<ClarityViewerSlice, [], [], ClarityViewerSlice> = (set) => ({
    clarityViewer: initialClarityViewerState,

    setClarityViewer: (state) => set({ clarityViewer: state }),
    updateClarityViewer: (partialState) => set((state) => ({ clarityViewer: { ...state.clarityViewer, ...partialState } })),
    showClarityViewer: () => set((state) => ({ clarityViewer: { ...state.clarityViewer, visible: true } })),
    hideClarityViewer: () => set((state) => ({ clarityViewer: { ...state.clarityViewer, visible: false } })),
});
